/* eslint-disable */;

import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  IdentityIdentifier: { input: any; output: any; }
};

/** Why a game ended */
export enum GameEndReason {
  /** Cancelled while waiting */
  Cancelled = 'CANCELLED',
  /** Four scoreless turns in a row */
  ScorelessTurns = 'SCORELESS_TURNS',
  /** The bag ran out and a player emptied their rack */
  WentOut = 'WENT_OUT'
}

export enum GameResult {
  Drew = 'DREW',
  Lost = 'LOST',
  Won = 'WON'
}

/** Where a game is in its life */
export enum GameStatus {
  /** Dealt and being played */
  Active = 'ACTIVE',
  /** Ended while waiting */
  Cancelled = 'CANCELLED',
  /** Ended by its last turn */
  Finished = 'FINISHED',
  /** Created; seat 2 is empty or the tiles are not yet dealt */
  Waiting = 'WAITING'
}

/** The order of the letters on the on-screen keyboard */
export enum KeyboardLayout {
  /** A to Z, in rows of the same lengths as QWERTY */
  Alphabetical = 'ALPHABETICAL',
  /** QWERTY order (the default) */
  Qwerty = 'QWERTY'
}

/** Why the rules refused a move (docs/game-rules.md section 3 for the placement rules) */
export enum MoveRefusalReason {
  BadBlankLetter = 'BAD_BLANK_LETTER',
  BadTime = 'BAD_TIME',
  Collision = 'COLLISION',
  GameOver = 'GAME_OVER',
  GapInLine = 'GAP_IN_LINE',
  MissesStart = 'MISSES_START',
  MixedDirections = 'MIXED_DIRECTIONS',
  MultiCharOnDiagonal = 'MULTI_CHAR_ON_DIAGONAL',
  NothingToSwap = 'NOTHING_TO_SWAP',
  NotAWord = 'NOT_A_WORD',
  NotConnected = 'NOT_CONNECTED',
  NotInLine = 'NOT_IN_LINE',
  NotInRack = 'NOT_IN_RACK',
  NotYourTurn = 'NOT_YOUR_TURN',
  NoTiles = 'NO_TILES',
  NoWordFormed = 'NO_WORD_FORMED',
  OutOfBounds = 'OUT_OF_BOUNDS',
  OverlapsHole = 'OVERLAPS_HOLE',
  RepeatedTile = 'REPEATED_TILE',
  SwappingOff = 'SWAPPING_OFF',
  SwapBiggerThanBag = 'SWAP_BIGGER_THAN_BAG',
  SwapEndsTurn = 'SWAP_ENDS_TURN',
  SwapNeedsPlayOrPass = 'SWAP_NEEDS_PLAY_OR_PASS',
  SwapOverLimit = 'SWAP_OVER_LIMIT'
}

/** A tile from the caller's rack and where it goes */
export type PlacedTileInput = {
  col: Scalars['Int']['input'];
  /** The rules engine's direction: h, v, dr or ur */
  dir: Scalars['String']['input'];
  /** A tile ID from myRack */
  id: Scalars['Int']['input'];
  /** A blank only: the letters it is played as, A to Z, as many as its face has */
  letter?: InputMaybe<Scalars['String']['input']>;
  row: Scalars['Int']['input'];
};

/** A play, a pass, or a swap that ended the turn */
export enum TurnKind {
  /** A scoreless turn; under then-play it may have swapped first */
  Pass = 'PASS',
  /** Laid tiles; under then-play it may have swapped first */
  Play = 'PLAY',
  /** A swap under ends-turn: the whole turn */
  Swap = 'SWAP'
}

export type Mutation = {
  __typename?: 'Mutation';
  /** Validates, moderates and saves the signed-in player's in-game display name, and returns their profile. Saving the name they already have changes nothing. At most 3 changes in any 24 hours */
  updateDisplayName: Profile;
  /** Saves the given settings to the signed-in player's account and returns all their settings */
  updateMySettings: PlayerSettings;
};


export type MutationUpdateDisplayNameArgs = {
  displayName: Scalars['String']['input'];
};


export type MutationUpdateMySettingsArgs = {
  input: PlayerSettingsInput;
};

/** The signed-in player's account settings, with defaults filled in for any they haven't changed */
export type PlayerSettings = {
  __typename?: 'PlayerSettings';
  keyboardLayout: KeyboardLayout;
  reducedMotion: ReducedMotion;
};

/** The settings to change. Only the fields given are saved */
export type PlayerSettingsInput = {
  keyboardLayout?: InputMaybe<KeyboardLayout>;
  reducedMotion?: InputMaybe<ReducedMotion>;
};

/** The signed-in player's profile, only ever shown to the player themselves */
export type Profile = {
  __typename?: 'Profile';
  /** The confirmed in-game name other players see, or null until the player confirms one */
  displayName?: Maybe<Scalars['String']['output']>;
  /** The account's email address, or null when it has none */
  email?: Maybe<Scalars['String']['output']>;
  /** Whether the account has the password provider, so it can reset a password */
  hasPassword: Scalars['Boolean']['output'];
  /** The name on the Firebase account (registered, or from a social sign-in), offered as a suggestion; never shown to other players */
  suggestedDisplayName?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  /** The signed-in player's profile, for the player themselves */
  myProfile: Profile;
  /** The signed-in player's settings */
  mySettings: PlayerSettings;
  who?: Maybe<WhoAmIEntity>;
};

/** Whether the game reduces motion: following the device, always, or never */
export enum ReducedMotion {
  /** Never reduce motion, even when the device asks for it */
  Off = 'OFF',
  /** Always reduce motion */
  On = 'ON',
  /** Follow the device's reduced motion setting (the default) */
  System = 'SYSTEM'
}

export type WhoAmIEntity = {
  __typename?: 'WhoAmIEntity';
  /** The name the player sees for themselves: their confirmed in-game name, or else the name on their Firebase account. Only for the player themselves: anything shown to other players reads the in-game name alone */
  displayName?: Maybe<Scalars['String']['output']>;
  /** The signed-in player's ID */
  identityId: Scalars['IdentityIdentifier']['output'];
};

export type BoardGameTileFieldsFragment = { __typename?: 'Tile', id: number, face: string, points: number };

export type BoardGameFieldsFragment = { __typename?: 'Game', id: string, status: GameStatus, endReason?: GameEndReason | null, rulesVersion: number, rules: any, turnNumber: number, isMyTurn: boolean, bagCount?: number | null, startCell?: { __typename?: 'Cell', row: number, col: number } | null, premiums: Array<{ __typename?: 'Premium', row: number, col: number, kind: string }>, players: Array<{ __typename?: 'GamePlayer', seat: number, isMe: boolean, displayName: string, score: number, result?: GameResult | null }>, board: Array<{ __typename?: 'PlacedTile', id: number, face: string, points: number, row: number, col: number, dir: string, letter?: string | null, turn: number, seat: number }>, myRack: Array<{ __typename?: 'Tile', id: number, face: string, points: number }>, turns: Array<{ __typename?: 'Turn', number: number, seat: number, kind: TurnKind, swappedCount: number, words: Array<{ __typename?: 'Word', word: string, points: number }>, points: { __typename?: 'TurnPoints', total: number } }> };

type MoveResultFields_Game_Fragment = { __typename?: 'Game', id: string, status: GameStatus, endReason?: GameEndReason | null, rulesVersion: number, rules: any, turnNumber: number, isMyTurn: boolean, bagCount?: number | null, startCell?: { __typename?: 'Cell', row: number, col: number } | null, premiums: Array<{ __typename?: 'Premium', row: number, col: number, kind: string }>, players: Array<{ __typename?: 'GamePlayer', seat: number, isMe: boolean, displayName: string, score: number, result?: GameResult | null }>, board: Array<{ __typename?: 'PlacedTile', id: number, face: string, points: number, row: number, col: number, dir: string, letter?: string | null, turn: number, seat: number }>, myRack: Array<{ __typename?: 'Tile', id: number, face: string, points: number }>, turns: Array<{ __typename?: 'Turn', number: number, seat: number, kind: TurnKind, swappedCount: number, words: Array<{ __typename?: 'Word', word: string, points: number }>, points: { __typename?: 'TurnPoints', total: number } }> };

type MoveResultFields_MoveRefused_Fragment = { __typename?: 'MoveRefused', reason: MoveRefusalReason, words: Array<string> };

export type MoveResultFieldsFragment = MoveResultFields_Game_Fragment | MoveResultFields_MoveRefused_Fragment;

export type GameQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GameQuery = { __typename?: 'Query', game: { __typename?: 'Game', id: string, status: GameStatus, endReason?: GameEndReason | null, rulesVersion: number, rules: any, turnNumber: number, isMyTurn: boolean, bagCount?: number | null, startCell?: { __typename?: 'Cell', row: number, col: number } | null, premiums: Array<{ __typename?: 'Premium', row: number, col: number, kind: string }>, players: Array<{ __typename?: 'GamePlayer', seat: number, isMe: boolean, displayName: string, score: number, result?: GameResult | null }>, board: Array<{ __typename?: 'PlacedTile', id: number, face: string, points: number, row: number, col: number, dir: string, letter?: string | null, turn: number, seat: number }>, myRack: Array<{ __typename?: 'Tile', id: number, face: string, points: number }>, turns: Array<{ __typename?: 'Turn', number: number, seat: number, kind: TurnKind, swappedCount: number, words: Array<{ __typename?: 'Word', word: string, points: number }>, points: { __typename?: 'TurnPoints', total: number } }> } };

export type PassTurnMutationVariables = Exact<{
  gameId: Scalars['ID']['input'];
  seenTurnNumber: Scalars['Int']['input'];
  swapped?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
}>;


export type PassTurnMutation = { __typename?: 'Mutation', passTurn: { __typename?: 'Game', id: string, status: GameStatus, endReason?: GameEndReason | null, rulesVersion: number, rules: any, turnNumber: number, isMyTurn: boolean, bagCount?: number | null, startCell?: { __typename?: 'Cell', row: number, col: number } | null, premiums: Array<{ __typename?: 'Premium', row: number, col: number, kind: string }>, players: Array<{ __typename?: 'GamePlayer', seat: number, isMe: boolean, displayName: string, score: number, result?: GameResult | null }>, board: Array<{ __typename?: 'PlacedTile', id: number, face: string, points: number, row: number, col: number, dir: string, letter?: string | null, turn: number, seat: number }>, myRack: Array<{ __typename?: 'Tile', id: number, face: string, points: number }>, turns: Array<{ __typename?: 'Turn', number: number, seat: number, kind: TurnKind, swappedCount: number, words: Array<{ __typename?: 'Word', word: string, points: number }>, points: { __typename?: 'TurnPoints', total: number } }> } | { __typename?: 'MoveRefused', reason: MoveRefusalReason, words: Array<string> } };

export type PlayMoveMutationVariables = Exact<{
  gameId: Scalars['ID']['input'];
  seenTurnNumber: Scalars['Int']['input'];
  placed: Array<PlacedTileInput> | PlacedTileInput;
  swapped?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
}>;


export type PlayMoveMutation = { __typename?: 'Mutation', playMove: { __typename?: 'Game', id: string, status: GameStatus, endReason?: GameEndReason | null, rulesVersion: number, rules: any, turnNumber: number, isMyTurn: boolean, bagCount?: number | null, startCell?: { __typename?: 'Cell', row: number, col: number } | null, premiums: Array<{ __typename?: 'Premium', row: number, col: number, kind: string }>, players: Array<{ __typename?: 'GamePlayer', seat: number, isMe: boolean, displayName: string, score: number, result?: GameResult | null }>, board: Array<{ __typename?: 'PlacedTile', id: number, face: string, points: number, row: number, col: number, dir: string, letter?: string | null, turn: number, seat: number }>, myRack: Array<{ __typename?: 'Tile', id: number, face: string, points: number }>, turns: Array<{ __typename?: 'Turn', number: number, seat: number, kind: TurnKind, swappedCount: number, words: Array<{ __typename?: 'Word', word: string, points: number }>, points: { __typename?: 'TurnPoints', total: number } }> } | { __typename?: 'MoveRefused', reason: MoveRefusalReason, words: Array<string> } };

export type SwapTilesMutationVariables = Exact<{
  gameId: Scalars['ID']['input'];
  seenTurnNumber: Scalars['Int']['input'];
  tiles: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type SwapTilesMutation = { __typename?: 'Mutation', swapTiles: { __typename?: 'Game', id: string, status: GameStatus, endReason?: GameEndReason | null, rulesVersion: number, rules: any, turnNumber: number, isMyTurn: boolean, bagCount?: number | null, startCell?: { __typename?: 'Cell', row: number, col: number } | null, premiums: Array<{ __typename?: 'Premium', row: number, col: number, kind: string }>, players: Array<{ __typename?: 'GamePlayer', seat: number, isMe: boolean, displayName: string, score: number, result?: GameResult | null }>, board: Array<{ __typename?: 'PlacedTile', id: number, face: string, points: number, row: number, col: number, dir: string, letter?: string | null, turn: number, seat: number }>, myRack: Array<{ __typename?: 'Tile', id: number, face: string, points: number }>, turns: Array<{ __typename?: 'Turn', number: number, seat: number, kind: TurnKind, swappedCount: number, words: Array<{ __typename?: 'Word', word: string, points: number }>, points: { __typename?: 'TurnPoints', total: number } }> } | { __typename?: 'MoveRefused', reason: MoveRefusalReason, words: Array<string> } };

export type CancelGameMutationVariables = Exact<{
  gameId: Scalars['ID']['input'];
}>;


export type CancelGameMutation = { __typename?: 'Mutation', cancelGame: { __typename?: 'Game', id: string, status: GameStatus, mySeat: number, isMyTurn: boolean, players: Array<{ __typename?: 'GamePlayer', seat: number, isMe: boolean, displayName: string }> } };

export type CreateGameMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateGameMutation = { __typename?: 'Mutation', createGame: { __typename?: 'Game', id: string, status: GameStatus, mySeat: number, isMyTurn: boolean, players: Array<{ __typename?: 'GamePlayer', seat: number, isMe: boolean, displayName: string }> } };

export type InviteToGameMutationVariables = Exact<{
  gameId: Scalars['ID']['input'];
}>;


export type InviteToGameMutation = { __typename?: 'Mutation', inviteToGame: { __typename?: 'GameInvitation', gameId: string, code: string } };

export type JoinGameMutationVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type JoinGameMutation = { __typename?: 'Mutation', joinGame: { __typename?: 'Game', id: string, status: GameStatus, mySeat: number, isMyTurn: boolean, players: Array<{ __typename?: 'GamePlayer', seat: number, isMe: boolean, displayName: string }> } };

export type LobbyGameFieldsFragment = { __typename?: 'Game', id: string, status: GameStatus, mySeat: number, isMyTurn: boolean, players: Array<{ __typename?: 'GamePlayer', seat: number, isMe: boolean, displayName: string }> };

export type MyGamesQueryVariables = Exact<{ [key: string]: never; }>;


export type MyGamesQuery = { __typename?: 'Query', myGames: { __typename?: 'MyGames', active: Array<{ __typename?: 'GameSummary', id: string, status: GameStatus, quickMatch: boolean, isMyTurn: boolean, turnNumber: number, updatedAt: any, me: { __typename?: 'GameSummarySeat', score: number, result?: GameResult | null }, opponent?: { __typename?: 'GameSummarySeat', displayName: string, score: number, result?: GameResult | null } | null }>, waiting: Array<{ __typename?: 'GameSummary', id: string, status: GameStatus, quickMatch: boolean, isMyTurn: boolean, turnNumber: number, updatedAt: any, me: { __typename?: 'GameSummarySeat', score: number, result?: GameResult | null }, opponent?: { __typename?: 'GameSummarySeat', displayName: string, score: number, result?: GameResult | null } | null }>, finished: Array<{ __typename?: 'GameSummary', id: string, status: GameStatus, quickMatch: boolean, isMyTurn: boolean, turnNumber: number, updatedAt: any, me: { __typename?: 'GameSummarySeat', score: number, result?: GameResult | null }, opponent?: { __typename?: 'GameSummarySeat', displayName: string, score: number, result?: GameResult | null } | null }> } };

export type GameSummaryFieldsFragment = { __typename?: 'GameSummary', id: string, status: GameStatus, quickMatch: boolean, isMyTurn: boolean, turnNumber: number, updatedAt: any, me: { __typename?: 'GameSummarySeat', score: number, result?: GameResult | null }, opponent?: { __typename?: 'GameSummarySeat', displayName: string, score: number, result?: GameResult | null } | null };

export type QuickMatchMutationVariables = Exact<{ [key: string]: never; }>;


export type QuickMatchMutation = { __typename?: 'Mutation', quickMatch: { __typename?: 'Game', id: string, status: GameStatus, mySeat: number, isMyTurn: boolean, players: Array<{ __typename?: 'GamePlayer', seat: number, isMe: boolean, displayName: string }> } };

export type MyProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type MyProfileQuery = { __typename?: 'Query', myProfile: { __typename?: 'Profile', displayName?: string | null, suggestedDisplayName?: string | null, email?: string | null, hasPassword: boolean } };

export type UpdateDisplayNameMutationVariables = Exact<{
  displayName: Scalars['String']['input'];
}>;


export type UpdateDisplayNameMutation = { __typename?: 'Mutation', updateDisplayName: { __typename?: 'Profile', displayName?: string | null, suggestedDisplayName?: string | null, email?: string | null, hasPassword: boolean } };

export type MySettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type MySettingsQuery = { __typename?: 'Query', mySettings: { __typename?: 'PlayerSettings', reducedMotion: ReducedMotion, keyboardLayout: KeyboardLayout } };

export type UpdateMySettingsMutationVariables = Exact<{
  input: PlayerSettingsInput;
}>;


export type UpdateMySettingsMutation = { __typename?: 'Mutation', updateMySettings: { __typename?: 'PlayerSettings', reducedMotion: ReducedMotion, keyboardLayout: KeyboardLayout } };

export type WhoAmIQueryVariables = Exact<{ [key: string]: never; }>;


export type WhoAmIQuery = { __typename?: 'Query', who?: { __typename?: 'WhoAmIEntity', identityId: any, displayName?: string | null } | null };


export const LobbyGameFieldsFragmentDoc = gql`
    fragment LobbyGameFields on Game {
  id
  status
  mySeat
  isMyTurn
  players {
    seat
    isMe
    displayName
  }
}
    `;
export const BoardGameTileFieldsFragmentDoc = gql`
    fragment BoardGameTileFields on Tile {
  id
  face
  points
}
    `;
export const BoardGameFieldsFragmentDoc = gql`
    fragment BoardGameFields on Game {
  id
  status
  endReason
  rulesVersion
  rules
  startCell {
    row
    col
  }
  premiums {
    row
    col
    kind
  }
  turnNumber
  isMyTurn
  players {
    seat
    isMe
    displayName
    score
    result
  }
  board {
    id
    face
    points
    row
    col
    dir
    letter
    turn
    seat
  }
  myRack {
    ...BoardGameTileFields
  }
  bagCount
  turns {
    number
    seat
    kind
    words {
      word
      points
    }
    points {
      total
    }
    swappedCount
  }
}
    ${BoardGameTileFieldsFragmentDoc}`;
export const MoveResultFieldsFragmentDoc = gql`
    fragment MoveResultFields on MoveResult {
  ... on Game {
    ...BoardGameFields
  }
  ... on MoveRefused {
    reason
    words
  }
}
    ${BoardGameFieldsFragmentDoc}`;
export const GameSummaryFieldsFragmentDoc = gql`
    fragment GameSummaryFields on GameSummary {
  id
  status
  quickMatch
  isMyTurn
  turnNumber
  me {
    score
    result
  }
  opponent {
    displayName
    score
    result
  }
  updatedAt
}
    `;
export const Game = gql`
    query game($id: ID!) {
  game(id: $id) {
    ...BoardGameFields
  }
}
    ${BoardGameFieldsFragmentDoc}`;
export const PassTurn = gql`
    mutation passTurn($gameId: ID!, $seenTurnNumber: Int!, $swapped: [Int!]) {
  passTurn(gameId: $gameId, seenTurnNumber: $seenTurnNumber, swapped: $swapped) {
    ...MoveResultFields
  }
}
    ${MoveResultFieldsFragmentDoc}`;
export const PlayMove = gql`
    mutation playMove($gameId: ID!, $seenTurnNumber: Int!, $placed: [PlacedTileInput!]!, $swapped: [Int!]) {
  playMove(gameId: $gameId, seenTurnNumber: $seenTurnNumber, placed: $placed, swapped: $swapped) {
    ...MoveResultFields
  }
}
    ${MoveResultFieldsFragmentDoc}`;
export const SwapTiles = gql`
    mutation swapTiles($gameId: ID!, $seenTurnNumber: Int!, $tiles: [Int!]!) {
  swapTiles(gameId: $gameId, seenTurnNumber: $seenTurnNumber, tiles: $tiles) {
    ...MoveResultFields
  }
}
    ${MoveResultFieldsFragmentDoc}`;
export const CancelGame = gql`
    mutation cancelGame($gameId: ID!) {
  cancelGame(gameId: $gameId) {
    ...LobbyGameFields
  }
}
    ${LobbyGameFieldsFragmentDoc}`;
export const CreateGame = gql`
    mutation createGame {
  createGame {
    ...LobbyGameFields
  }
}
    ${LobbyGameFieldsFragmentDoc}`;
export const InviteToGame = gql`
    mutation inviteToGame($gameId: ID!) {
  inviteToGame(gameId: $gameId) {
    gameId
    code
  }
}
    `;
export const JoinGame = gql`
    mutation joinGame($code: String!) {
  joinGame(code: $code) {
    ...LobbyGameFields
  }
}
    ${LobbyGameFieldsFragmentDoc}`;
export const MyGames = gql`
    query myGames {
  myGames {
    active {
      ...GameSummaryFields
    }
    waiting {
      ...GameSummaryFields
    }
    finished {
      ...GameSummaryFields
    }
  }
}
    ${GameSummaryFieldsFragmentDoc}`;
export const QuickMatch = gql`
    mutation quickMatch {
  quickMatch {
    ...LobbyGameFields
  }
}
    ${LobbyGameFieldsFragmentDoc}`;
export const MyProfile = gql`
    query myProfile {
  myProfile {
    displayName
    suggestedDisplayName
    email
    hasPassword
  }
}
    `;
export const UpdateDisplayName = gql`
    mutation updateDisplayName($displayName: String!) {
  updateDisplayName(displayName: $displayName) {
    displayName
    suggestedDisplayName
    email
    hasPassword
  }
}
    `;
export const MySettings = gql`
    query mySettings {
  mySettings {
    reducedMotion
    keyboardLayout
  }
}
    `;
export const UpdateMySettings = gql`
    mutation updateMySettings($input: PlayerSettingsInput!) {
  updateMySettings(input: $input) {
    reducedMotion
    keyboardLayout
  }
}
    `;
export const WhoAmI = gql`
    query whoAmI {
  who {
    identityId
    displayName
  }
}
    `;

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "MoveResult": [
      "Game",
      "MoveRefused"
    ]
  }
};
      export default result;
    